import React from 'react';
import '../CSS/App.css';
import { NavScroll } from './NavBar';
import SocialLinks from "./SocialLinks";

export default function About() {
  return (
<div className='background-component'>
  {/* This will render whatever NavScroll returns */}
  <NavScroll />
  <SocialLinks />
  {/* the rest of your layout */}
  <main>
    <div className='aboutText'>
    <h1 className='aboutTitle'>what is halo extravalanza?</h1>
    <p>Established 2021 in Milwaukee, Wisconsin, we are a community of friends and recreational Halo players that revere the glory days of LAN. We thrive on competition, talkin' trash, and IRL hangs
      (with a huge spread of food, of course)! In conjunction with our discord, this Halo LAN league is a conduit that keeps us connected, and we want to prove to the masses that LAN is not Dead.
      So, instead . . . we modernized it.
    </p>
    <p>
      We have 44 players across the midwest with an ever-growing waitlist. Players are drafted to one of four squads by corresponding co-captains before the start of the season, Each LAN is comprised
      of two halves featuring a full slate of 16 players with player and team changes at the midpoint when reinforcements are deployed. Each LAN als ofeatures two concurrent streams spanning 9 hours, showcasing multiple vantage
      points of the fun, competition, carnage, and trash-talk.
    </p>
    <p>
      We play Halo 3 on the Master Chief Collection using four XSXs and OLED TVs. An innovative scoring model is used to evaluate squad performance. Individual player output is also captured, then fed into a propietary
      algorithm to quantify player-ratings. These ratings facilitate a sophisticated team-balancing approach that ensures events are fun adn competitive regardless of the skill pool. There will never be a substitute
      for persistent comms and teamwork, however, giving credence to our mantra: "Stay Together, Slay Together."
    </p>
    <p style={{ textAlign: 'center' }}>
      Seize the revival of Halo LAN with us!
    </p>
    </div>
  </main>



<script type="module" src="https://unpkg.com/ionicons@5.5.2/dist/ionicons/ionicons.esm.js"></script>
<script nomodule src="https://unpkg.com/ionicons@5.5.2/dist/ionicons/ionicons.js"></script>



</div>
  );
}
